export default function Producers() {
    return (
        <section
            id="producers"
            className="relative px-6 md:px-10 py-16 md:py-24 bg-[#F1E8D5]"
            data-testid="producers-section"
        >
            <div className="max-w-7xl mx-auto">
                <div className="reveal mb-10 md:mb-14 max-w-3xl">
                    <h2 className="font-display tracking-tighter font-black leading-[0.95] text-5xl md:text-6xl lg:text-7xl text-black">
                        Behind every
                        {" "}
                        <em className="not-italic bg-[#C2410C] text-white px-3 -rotate-1 inline-block">great song.</em>
                    </h2>
                </div>

                <div className="reveal grid md:grid-cols-12 gap-8 md:gap-12">
                    <div className="md:col-span-7 space-y-5 text-stone-800 text-base md:text-lg leading-relaxed">
                        <p>
                            Every My First Single project is a collaboration
                            between you, your vocal coach and our
                            creative and production team &mdash; bringing
                            together your ideas, your coach&rsquo;s
                            understanding of your voice and our specialist
                            expertise to create a professionally produced song
                            that feels genuinely personal.
                        </p>
                        <p className="font-display font-bold text-xl md:text-2xl leading-snug text-black">
                            But most importantly, your song is created{" "}
                            <span className="bg-[#D4A017] text-black px-2 -rotate-1 inline-block">with</span>{" "}
                            you, not for you.
                        </p>
                        <p>
                            Every project begins with your{" "}
                            <span className="font-bold">Song Profile</span>,
                            capturing your ideas, musical influences, personal
                            story and creative vision. This becomes the
                            foundation for everything that follows.
                        </p>
                        <p>
                            Whether you&rsquo;re creating an original song or
                            recording your own interpretation of a favourite,
                            the creative process is shaped around you.
                        </p>
                        <p>
                            For an original song, our creative team will
                            develop your ideas into professionally written
                            lyrics for you to review, refine and approve.
                        </p>
                        <p>
                            If you&rsquo;ve chosen an existing song, we&rsquo;ll
                            work with you and your vocal coach to shape the
                            style, feel and interpretation so the finished
                            version reflects your personality and the way you
                            want to perform it.
                        </p>
                        <p className="font-display font-bold text-lg text-[#7C2D12]">
                            Nothing moves forward until you love the lyrics.
                        </p>
                        <p>
                            Once the lyrics have been agreed, we begin creating
                            the music. Using your preferred style, influences
                            and the emotion you want your song to convey,
                            we&rsquo;ll produce a professionally arranged
                            backing track that brings your song to life.
                        </p>
                        <p>
                            Again, you&rsquo;ll have the opportunity to listen,
                            review and provide feedback. If something
                            doesn&rsquo;t feel quite right, we&rsquo;ll work
                            with you to refine it.
                        </p>
                        <p className="font-display font-bold text-lg text-[#1B4D3E]">
                            Only when you&rsquo;re genuinely happy do we move
                            on to the next stage.
                        </p>
                        <p>
                            Once you&rsquo;ve recorded your vocal with your
                            My First Single vocal coach, our production team
                            carefully edits, balances, mixes and masters every
                            element of the track, creating a polished,
                            commercial‑quality recording ready for release.
                        </p>
                        <p>
                            Every song undergoes a final quality review and is
                            then shared with you for your final seal of
                            approval. Only when you&rsquo;re completely happy
                            is the finished track prepared for digital
                            distribution.
                        </p>
                    </div>

                    <aside className="md:col-span-5 md:sticky md:top-24 self-start bg-[#0A0A0A] text-white rounded-3xl p-7 md:p-8 border-2 border-black shadow-[6px_6px_0_0_#D4A017] relative overflow-hidden">
                        <div className="absolute -top-16 -right-16 w-52 h-52 rounded-full bg-[#C2410C] opacity-30 blur-3xl" aria-hidden />
                        <div className="relative">
                            <p className="text-white/85 text-base md:text-lg leading-relaxed">
                                Throughout the entire journey, you&rsquo;re
                                involved in every important creative decision.
                            </p>
                            <p className="mt-5 text-white/80 text-[15px] leading-relaxed">
                                Because this isn&rsquo;t about creating the
                                song we think you should have. It&rsquo;s
                                about creating the song you&rsquo;ve always
                                wanted.
                            </p>

                            <div className="mt-8 space-y-1 font-display font-black tracking-tighter text-3xl md:text-4xl leading-[1.05]">
                                <div className="text-[#D4A017]">Your ideas.</div>
                                <div className="text-white">Your story.</div>
                                <div className="text-[#C2410C]">Your voice.</div>
                            </div>

                            <p className="mt-6 text-white/80 text-[14px] leading-relaxed">
                                Professionally crafted into a song you&rsquo;ll
                                be proud to call your own.
                            </p>
                        </div>
                    </aside>
                </div>
            </div>
        </section>
    );
}
